import React from "react";
import { AppIconButtonWithOutline } from "theme/buttons/app-icon-button-with-outline";

export const AddPaymentMethodButton = ({ onPress }) => (
  <AppIconButtonWithOutline onPress={onPress} name={"plus"} />
);
